module.exports = __webpack_public_path__ + "static/media/Data_Usage.af2cfe99.svg";